import React from 'react';
import ProductDetails from '../components/ProductDetails/ProductDetails';

const ProductPage = () => <ProductDetails />;

export default ProductPage;
